<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="square" stroke-linejoin="miter" aria-hidden="true">
    <polyline points="2,4 5,4 7,17 19,17 21,7 6,7"/>
    <circle cx="9" cy="21" r="1.4" fill="currentColor"/>
    <circle cx="17" cy="21" r="1.4" fill="currentColor"/>
  </svg>
</template>
